module.exports = __webpack_public_path__ + "img/11bombas.26e5b82f.jpg";